import Splide from '@splidejs/splide'
import { Popup } from "./popup";
// import { windowWidth } from "./utils";

const sliders = {
  init() {
    this.heroSlider();
    this.topSlider();
    this.catSlider()
    this.prodSliders();
    this.popCatSlider();
    this.setTestimonialsSliders();
    this.brandsSlider();
    this.blogs();
    this.setProdThumbnailsSlider();
    this.resetSlider();
  },


    resetSlider() {
    window.addEventListener("reset", () => {
      this.setProdThumbnailsSlider();
    });
  },

    setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById("mainImage") as HTMLElement | undefined
    const thumbnails = document.getElementById("thumbnails") as HTMLElement | undefined

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: 'carousel',
        pagination: true,
        arrows: false,
        
        breakpoints: {
          1024: {
            arrows: false
          }
        }
      })

      const thumbnailsNav = new Splide(thumbnails, {
        
        isNavigation: true,
        type: 'carousel',
        pagination: false,
        heightRatio: 4,
        perPage: 4,
        arrow: true,
        gap: "20px",
        breakpoints: {
          767: {
            direction: "ltr",
            perPage: 3,
            heightRatio: 1,
            fixedHeight: "70px",
          },
        },
      })

      main.sync(thumbnailsNav)
      main.mount()
      thumbnailsNav.mount()
    }
  },

    blogs() {
    const slider = document.getElementById('blogs') as
      | HTMLElement
      | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 3,
        type: 'carousel',
        pagination: false,
        arrows: true,
        gap: '55px',
        breakpoints: {
          1250: {
            drag: true, 
            perPage: 2, 
            perMove: 1,
          },

            768: {
            drag: true, 
            perPage: 1, 
            perMove: 1,
            arrows: false,
            pagination: false,
          },
          
            500: {
            drag: true, 
            perPage: 1, 
            perMove: 1,
            arrows: false,
            pagination: false,
 
          }
        }
      }).mount()
    }
  },



      brandsSlider() {
    const slider = document.getElementById('brands') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 7,
        type: 'carousel',
        pagination: false,
        arrows: false,
        speed: 800,
        gap: '44px',
        breakpoints: {
          768: {
            perPage: 4,
            pagination: false,
            gap: '15px'
          },

          500: {
            perPage: 2, 
            padding: { right: "30%" },
          }

        },
      }).mount()
    }
  },


  
  heroSlider() {
    const heroSliders = document.querySelectorAll(".jsHeroSlide") as NodeListOf<HTMLElement>
    heroSliders.forEach((el) => {
      const slider = new Splide(el, {
        perPage: 1,
        type: 'fade',
        speed: 1500,
        arrows: true,
        pagination: true,
        autoplay: true,

      })
      slider.mount()
    })
  },

  setTestimonialsSliders() {
    const heroSliders = document.querySelectorAll(".jsTestimonialsSlide") as NodeListOf<HTMLElement>
    heroSliders.forEach((el) => {
      const slider = new Splide(el, {
        perPage: 1,
        type: 'fade',
        speed: 1500,
        arrows: false,
        pagination: true,
        autoplay: true,

      })
      slider.mount()
    })
  },


  topSlider() {
    const slider = document.querySelectorAll('.topSliders') as NodeListOf<
      HTMLElement
    >

    slider.forEach((slide) => {
      new Splide(slide, {
        perPage: 1,
        type: 'loop',
        direction: 'ttb',
        pagination: false,
        arrows: false,
        speed: 800,
        gap: '20px',
        heightRatio: 1,
        fixedHeight: '45px',
        autoplay: true,
        destroy: true,
     
        breakpoints: {
          767: {
             fixedHeight: '30px',
             destroy: false
          },
        },
      }).mount()
    })
  },

    popCatSlider() {
    const slider = document.querySelectorAll('.popCatsSliders') as NodeListOf<
      HTMLElement
    >

    slider.forEach((slide) => {
      new Splide(slide, {
        perPage: 1,
        type: 'loop',
       
        pagination: false,
        arrows: false,
        speed: 800,
        gap: '20px',

        autoplay: true,
        destroy: true,
     
        breakpoints: {
          767: {
              pagination: true,
             destroy: false
          },
        },
      }).mount()
    })
  },

    catSlider() {
    const slider = document.querySelectorAll('.catSliders') as NodeListOf<
      HTMLElement
    >

    slider.forEach((slide) => {
      new Splide(slide, {
        perPage: 5,
        type: 'carousel',
      
        pagination: false,
        arrows: false,
        speed: 800,
        gap: '20px',

        destroy: true,
     
        breakpoints: {
          1249: {
          arrows: true,
          destroy: false,
          perPage: 4,
          gap: '20px',
          },

          768: {
             perPage: 2,
             padding: { right: "30%" },
          },

          500: {
             perPage: 1,
            padding: { right: "30%" },
            gap: '20px'

          },
        },
      }).mount()
    })
  },

      prodSliders() {
    const slider = document.querySelectorAll('.jsProdSliders') as NodeListOf<
      HTMLElement
    >

    slider.forEach((slide) => {
      new Splide(slide, {
        type: 'carousel',
        arrows: true,
        pagination: false,
        gap: '15px',
        perMove: 1, 
        perPage: 5,
        speed: 1200,
        breakpoints: {
          1400: {
            perPage: 3,
         
          },

          990: {
            perPage: 3,
         
          },

          768: {
            perPage: 2,
            arrow: false,
           
          },

          500: {
            perPage: 1,
            arrows: false,
            gap: '10px',
            perMove: 1,
            padding: { right: "30%" },
          
          },
        },
      }).mount()
    })
  },


}

export default sliders